export interface ILocation {
  name: string;
  value: string;
}
export const locationUSA: ILocation[] = [
  { name: 'Tukwila (Seattle) WA', value: 'Tukwila (Seattle) WA' },
  { name: 'Spokane WA', value: 'Spokane WA' },
  { name: 'Tacoma WA ', value: 'Tacoma WA ' },
  { name: 'Portland OR', value: 'Portland OR' },
  { name: 'Sacramento CA', value: 'Sacramento CA' },
  { name: 'San Francisco CA ', value: 'San Francisco CA ' },
  { name: 'Berkeley CA ', value: 'Berkeley CA ' },
  { name: 'Las Vegas NV ', value: 'Las Vegas NV' },
  { name: 'Anaheim CA', value: 'Anaheim CA' },
  { name: 'Salt Lake City UT', value: 'Salt Lake City UT' },
  { name: 'Waipahu HI', value: 'Waipahu HI' },
  { name: 'Kalihi HI ', value: 'Kalihi HI ' },

  { name: 'Highland IN', value: 'Highland IN' },
  { name: 'South Bend IN ', value: 'South Bend IN ' },
  { name: 'Lafayette IN ', value: 'Lafayette IN ' },
  { name: 'Indianapolis IN', value: 'Indianapolis IN' },

  { name: 'Dallas TX', value: 'Dallas TX' },

  { name: 'East Dallas TX ', value: 'East Dallas TX ' },
  { name: 'Fort Worth TX ', value: 'Fort Worth TX ' },
  { name: 'San Antonio TX', value: 'San Antonio TX' },
  { name: 'Lubbock TX ', value: 'Lubbock TX ' },
  { name: 'Albuquerque NM', value: 'Albuquerque NM' },
  { name: 'Phoenix AZ', value: 'Phoenix AZ' },
  { name: 'Tempe AZ ', value: 'Tempe AZ ' },
  { name: 'Tucson AZ ', value: 'Tucson AZ ' },
  { name: 'Houston TX', value: 'Houston TX' },
  { name: 'Miami Gardens FL', value: 'Miami Gardens FL' },
  { name: 'Clearwater FL ', value: 'Clearwater FL ' },
  { name: 'Orlando FL ', value: 'Orlando FL ' },
  { name: 'New Orleans LA', value: 'New Orleans LA' },
  { name: 'Spring TX', value: 'Spring TX' },
  { name: 'North Tampa FL', value: 'North Tampa FL' },
  { name: 'Baton Rouge LA', value: 'Baton Rouge LA' },
  { name: 'Richardson TX', value: 'Richardson TX' }
];
export const locationCA: ILocation[] = [
  {
    name: 'Coquitlam DC',
    value: 'Coquitlam DC'
  },

  { name: 'Edmonton', value: 'Edmonton' },
  { name: 'Calgary', value: 'Calgary' },
  { name: 'Victoria', value: 'Victoria' },
  { name: 'Saskatoon', value: 'Saskatoon' },
  { name: 'Winnipeg', value: 'Winnipeg' },
  { name: 'Vancouver', value: 'Vancouver' },
  { name: 'Richmond', value: 'Richmond' },
  { name: 'Surrey', value: 'Surrey' },
  { name: 'Coquitlam Express', value: 'Coquitlam Express' },
  { name: 'Cloverdale', value: 'Cloverdale' },
  { name: 'S.Calgary Express', value: 'S.Calgary Express' },
  { name: 'N.Calgary Express', value: 'N.Calgary Express' },
  { name: 'Red Deer', value: 'Red Deer' },
  { name: 'Edmonton Express', value: 'Edmonton Express' },
  { name: 'Abbotsford', value: 'Abbotsford' },
  { name: 'Calgary Crowfoot', value: 'Calgary Crowfoot' },
  { name: 'Vancouver Express', value: 'Vancouver Express' },
  { name: 'Saskatoon Express', value: 'Saskatoon Express' },

  { name: 'Calgary DC', value: 'Calgary DC' },
  { name: 'Ontario DC', value: 'Ontario DC' },
  { name: 'Waterloo', value: 'Waterloo' },
  { name: 'Mississauga Dundas', value: 'Mississauga Dundas' },
  { name: 'Toronto Caledonia', value: 'Toronto Caledonia' },
  { name: 'Scarborough', value: 'Scarborough' },
  { name: 'Ottawa Bank St', value: 'Ottawa Bank St' },
  {
    name: 'Montreal DC',
    value: 'Montreal DC'
  },
  { name: 'Quebec City', value: 'Quebec City' },
  { name: 'Laval', value: 'Laval' },
  {
    name: 'Dartmouth DC',
    value: 'Dartmouth DC'
  }
];
